import { App } from 'vue';

import HeaderCartIcon from '@/components/Cart/HeaderCartIcon/HeaderCartIcon.vue';

import type { InitializationState } from './index';
import { headerCartIconMountSelector } from './index';
import { initializeComponent } from './shared';

export const initHeaderCartIcon = async (
  waitForCartUpdate = false,
  mountedApps: Map<string, App>,
  initializationState: InitializationState
): Promise<void> => {
  await initializeComponent({
    containerId: 'header-cart-icon',
    mountSelector: headerCartIconMountSelector,
    component: HeaderCartIcon,
    state: initializationState.headerCartIcon,
    mountedApps,
    waitForCartUpdate,
    extractProps: (container) => ({
      initialItemCount: parseInt(container.dataset.itemCount ?? '0', 10)
    })
  });
};
